import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import { colors } from '../../theme';
import { APP_PATHS } from '../../routes/paths';

const ThankYouPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        backgroundColor: colors.deepNavy,
        color: colors.pureWhite,
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2.25rem', md: '3.5rem' },
            fontWeight: 700,
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            marginBottom: '24px',
            color: colors.pureWhite,
          }}
        >
          Thank you for your<br />interest in <Box component="span" sx={{ color: colors.signalOrange, whiteSpace: 'nowrap' }}>filtrd.</Box>
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: '1rem', md: '1.25rem' },
            color: colors.slate[400],
            maxWidth: '600px',
            margin: '0 auto',
            marginTop: '24px',
            lineHeight: 1.6,
          }}
        >
          We look forward to helping you reclaim your attention while remaining informed about what matters to you.
        </Typography>

        <Box sx={{ marginTop: '32px' }}>
          <Button
            variant="contained"
            onClick={() => navigate(APP_PATHS.landing)}
            sx={{
              backgroundColor: colors.signalOrange,
              color: colors.pureWhite,
              fontWeight: 600,
              padding: '16px 32px',
              borderRadius: '8px',
              textTransform: 'none',
              fontSize: '1rem',
              '&:hover': {
                backgroundColor: colors.signalOrangeHover,
                transform: 'translateY(-1px)',
                boxShadow: `0 4px 12px ${colors.shadows.orange}`,
              },
            }}
          >
            Return to Main Page
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default ThankYouPage;
